import { useEffect, useMemo, useRef, useState } from "react";

import { useDebounce } from "utils/useDebounce";

import { buildEmptyFilters, buildFilterQuery } from "./filterModel";

// State for a <FilterPanel> screen. `fields` may change over time (e.g. a filter
// that only owners get), and the state keeps in step with it. `query` is
// { param: value } for every switched-on, filled-in filter, debounced so typing
// isn't sent on every keystroke. `onQueryChange` fires when the debounced query
// changes (not on mount) — use it to go back to page 1.
export const useFilterPanel = (fields, onQueryChange) => {
  const [filters, setFilters] = useState({});
  const activeFilters = useMemo(() => ({ ...buildEmptyFilters(fields), ...filters }), [fields, filters]);

  const queryKey = JSON.stringify(buildFilterQuery(activeFilters, fields));
  const debouncedQueryKey = useDebounce(queryKey, 400);
  const query = useMemo(() => JSON.parse(debouncedQueryKey), [debouncedQueryKey]);

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (onQueryChange) onQueryChange();
    // Only a changed query should trigger this, not the callback's identity.
  }, [debouncedQueryKey]);

  return { filters: activeFilters, setFilters, query };
};
